import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cmsClient } from "src/services/cmsClient";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";

const updateObservationCategory = async ({
	name,
	categoryId
}: {
	name: string;
	categoryId: number;
}) => {
	const url = `/observations/admin/forms/categories/${categoryId}/`;
	const response = await cmsClient.patch(url, { name });

	return response.data;
};

const useUpdateObservationCategory = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		queryClient.invalidateQueries(["observation-categories"]);

		toast.success(
			<CustomToast type="Success" message="Category updated successfully" />,
			{ hideProgressBar: true }
		);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation({
		mutationFn: updateObservationCategory,
		onSuccess,
		onError
	});

	return mutation;
};

export default useUpdateObservationCategory;
